// texe-web/src/pages/VerifyEmail.tsx
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api/index";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Geçersiz doğrulama bağlantısı.");
      return;
    }

    const verify = async () => {
      try {
        const res = await api.get<{ ok: boolean; message?: string }>(
          `/api/auth/verify?token=${encodeURIComponent(token)}`
        );
        if (res.ok) {
          setStatus("success");
          setMessage(res.message || "E-postanız başarıyla doğrulandı!");
        } else {
          setStatus("error");
          setMessage("E-posta doğrulanamadı.");
        }
      } catch (err: any) {
        setStatus("error");
        setMessage(err?.response?.data?.error || err?.message || "Bir hata oluştu.");
      }
    };

    verify();
  }, [token]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
          padding: "48px 40px",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Logo */}
        <div style={{ marginBottom: "24px" }}>
          <img
            src="/logo/savnot-icon-dark-64.png"
            alt="SavNot"
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "16px",
              margin: "0 auto",
              display: "block",
            }}
          />
        </div>

        {/* Site Adı */}
        <h1
          style={{
            fontSize: "28px",
            fontWeight: "700",
            color: "#1a1a1a",
            marginBottom: "8px",
          }}
        >
          SavNot
        </h1>

        {status === "loading" && (
          <div style={{ padding: "32px 0" }}>
            <div
              style={{
                width: "48px",
                height: "48px",
                border: "4px solid #f3f4f6",
                borderTop: "4px solid #667eea",
                borderRadius: "50%",
                margin: "0 auto 16px",
                animation: "spin 1s linear infinite",
              }}
            />
            <p style={{ color: "#666", fontSize: "16px" }}>E-postanız doğrulanıyor...</p>
          </div>
        )}

        {status === "success" && (
          <div style={{ padding: "24px 0" }}>
            {/* Yeşil Tik İkonu */}
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "#10b981",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                animation: "scaleIn 0.5s ease-out",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={3}
                stroke="white"
                style={{ width: "48px", height: "48px" }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>

            <h2
              style={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#10b981",
                marginBottom: "12px",
              }}
            >
              E-postanız Doğrulandı!
            </h2>

            <p
              style={{
                color: "#666",
                fontSize: "15px",
                lineHeight: "1.6",
                marginBottom: "32px",
              }}
            >
              {message || "Hesabınız başarıyla aktif edildi. Artık SavNot'u kullanmaya başlayabilirsiniz."}
            </p>

            <Link
              to="/feed"
              style={{
                display: "inline-block",
                background: "#667eea",
                color: "#fff",
                textDecoration: "none",
                padding: "14px 32px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "16px",
                transition: "background 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#5568d3")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#667eea")}
            >
              Keşfet
            </Link>
          </div>
        )}

        {status === "error" && (
          <div style={{ padding: "24px 0" }}>
            {/* Kırmızı X İkonu */}
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "#ef4444",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={3}
                stroke="white"
                style={{ width: "48px", height: "48px" }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>

            <h2
              style={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#ef4444",
                marginBottom: "12px",
              }}
            >
              Doğrulama Başarısız
            </h2>

            <p
              style={{
                color: "#666",
                fontSize: "15px",
                lineHeight: "1.6",
                marginBottom: "32px",
              }}
            >
              {message || "E-posta doğrulanamadı. Lütfen tekrar deneyin."}
            </p>

            <Link
              to="/"
              style={{
                display: "inline-block",
                background: "#64748b",
                color: "#fff",
                textDecoration: "none",
                padding: "14px 32px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "16px",
                transition: "background 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#475569")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#64748b")}
            >
              Ana Sayfaya Dön
            </Link>
          </div>
        )}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes scaleIn {
            0% { transform: scale(0); opacity: 0; }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); opacity: 1; }
          }
        `}</style>
      </div>
    </div>
  );
}
